export const ru = {
    close: 'Закрыть',
};
